import { Audio } from '../audio-card-section/AudioCardSection';

export const VOICE_IDS = {
  DEREK: '908f7846-fb50-3dd5-b37b-6b91661a6101',
  CHARLIE: 'd99a6d9e-124f-3390-b5cd-b183be3f28dc',
  RACHEL: 'd285f5e7-6205-39fe-8df8-8486bfd59547',
  ADDISON: '21fd55f2-8b3e-3519-a152-b78ef1fd01fa',
};

export const voices: Audio[] = [
  {
    name: 'Addison',
    image: '/images/gen-ai/ai-voice-addison.png',
    audio:
      'https://adstudio-assets.scdn.co/mp3/b4c38e12600719cb5660c45591f97d9871d3fef7.mp3',
    audioId: VOICE_IDS.ADDISON,
  },
  {
    name: 'Charlie',
    image: '/images/gen-ai/ai-voice-charlie.png',
    audio:
      'https://adstudio-assets.scdn.co/mp3/e8c4781b3d4a837b14a0c199d332458227142ace.mp3',
    audioId: VOICE_IDS.CHARLIE,
  },
  {
    name: 'Derek',
    image: '/images/gen-ai/ai-voice-derek.png',
    audio:
      'https://adstudio-assets.scdn.co/mp3/36f2d18e11b53c5f392faa6aa363b3c96534c16e.mp3',
    audioId: VOICE_IDS.DEREK,
  },
  {
    name: 'Rachel',
    image: '/images/gen-ai/ai-voice-rachel.png',
    audio:
      'https://adstudio-assets.scdn.co/mp3/37e4306936cf337789d65364616beb1f9ee48373.mp3',
    audioId: VOICE_IDS.RACHEL,
  },
];
